import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getNotificationPermits } from 'modules/settings/api';

export const useQueryGetNotificationPermits = ({
  onlyRepresentativeObjects,
}: {
  onlyRepresentativeObjects: string;
}) => {
  return useQuery(
    [QUERY_KEYS.SETTINGS_NOTIFICATION_PERMITS, onlyRepresentativeObjects],
    () => getNotificationPermits({ onlyRepresentativeObjects }),
    { cacheTime: 0, keepPreviousData: true },
  );
};
